import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../base/BaseComponent";
import {Dropdown, Icon, Input, Menu} from "antd";
import {Scrollbars} from "react-custom-scrollbars";

const {Search} = Input;


export default class Company extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            dataSource: [],
            company: '单位不限',
            visible: false
        }
    }

    componentWillMount() {
        this.getCompany()
    }

    componentDidMount() {

    }


    //获取部门数据
    getCompany = (value) => {
        let param = {
            nameOrCode: value,
            page: 1,
            size: 1000
        };
        this.request({
            url: '/cm-sites-sys/dept/conditionQuery',
            method: "post",
            body: param,
            loading: false,
            contentType: 'json',
            callBack: (res) => {
                let data = [];
                if (res && res.data) {
                    data = res.data;
                    data.unshift({name: '单位不限', id: '1'});
                    this.state.count = res.count
                }
                this.setState({dataSource: data})
            },
        });
    };
    render() {
        return (
            <Dropdown
                onClick={() => {
                this.state.searchText = "";
                this.getCompany("")
            }}
                overlay={this.renderCompany()}
                      trigger={["click"]} style={{display: 'none'}}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}>
                    {this.state.company}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }
    renderCompany() {
        let {dataSource} = this.state;
        return (
            <Menu onClick={()=>{
                this.setState({})
            }}
                  ref={ref=>this.menu=ref}
                  style={{marginTop:'7px'}}>
                <div style={{
                    fontSize: '12px',
                    width: '300px',
                    background: '#ffffff',
                    padding: '10px',
                    marginTop: '-4px'
                }}>
                    <Search
                        placeholder="请输入关键字"
                        allowClear={true}
                        value={this.state.searchText}
                        onSearch={value => {
                            this.state.searchText = value;
                            this.getCompany(value)
                        }}
                        onChange={(e) => {
                            this.setState({searchText: e.target.value})
                        }}
                    />
                    <Scrollbars autoHeight autoHeightMax={300} style={{marginTop: '16px'}}>
                        <div style={{display: 'flex', flexWrap: 'wrap',paddingRight:"10px"}}>
                            {
                                dataSource && dataSource.length && dataSource.map((item, index) => {
                                    return (
                                        <span style={{padding: 5, cursor: 'pointer'}} key={index} onClick={() => {
                                            this.state.visible = false;
                                            this.state.company = item.name;
                                            let dept = '单位不限';
                                            if(!(item.id ==='1')){
                                                dept = item.id;
                                            }
                                            this.props.onClickCall && this.props.onClickCall([{type:"deptId", data:dept}]);
                                            this.setState({});
                                            this.menu.props.onClick()
                                        }}>{item.name}</span>
                                    )
                                })
                            }
                        </div>
                    </Scrollbars>
                </div>
            </Menu>
        )
    }

}